import * as i2 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, TemplateRef, Component, ViewEncapsulation, Input, ViewChild, Output, HostListener, Directive, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i5 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i3 from '@niceltd/sol/calendar';
import { CalendarModule } from '@niceltd/sol/calendar';
import * as i1 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
import * as i4 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i6 from '@niceltd/sol/time-picker';
import { TimePickerModule } from '@niceltd/sol/time-picker';
import * as i3$1 from '@niceltd/sol/text-input';
import { TextInputModule } from '@niceltd/sol/text-input';
import { TemplatePortal } from '@angular/cdk/portal';
import { Subscription, merge } from 'rxjs';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { languageInitializerProvider } from '@niceltd/sol';
const _c0 = ["timepicker"];
const _c1 = ["calendar"];
function DatepickerTemplate_ng_template_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "sol-button", 9);
    i0.ɵɵlistener("onClick", function DatepickerTemplate_ng_template_0_div_6_Template_sol_button_onClick_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r5.selectToday());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("variant", "text")("size", "large")("ariaLabel", ctx_r3.getTodayLabel())("disabledAltState", true)("disabled", !ctx_r3.isWithinRange());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.getTodayLabel());
  }
}
function DatepickerTemplate_ng_template_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "sol-time-picker", 12, 13);
    i0.ɵɵtwoWayListener("ngModelChange", function DatepickerTemplate_ng_template_0_div_7_Template_sol_time_picker_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r8.selectedDateTime, $event) || (ctx_r8.selectedDateTime = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("timeChanged", function DatepickerTemplate_ng_template_0_div_7_Template_sol_time_picker_timeChanged_2_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r10 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r10.timeSelection($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r4.selectedDateTime);
    i0.ɵɵproperty("alwaysOpen", true);
  }
}
function DatepickerTemplate_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2)(3, "div", 3)(4, "sol-calendar", 4, 5);
    i0.ɵɵtwoWayListener("ngModelChange", function DatepickerTemplate_ng_template_0_Template_sol_calendar_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r11 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r11.selectedDate, $event) || (ctx_r11.selectedDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("dateSelected", function DatepickerTemplate_ng_template_0_Template_sol_calendar_dateSelected_4_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.dateSelection($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, DatepickerTemplate_ng_template_0_div_6_Template, 3, 6, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, DatepickerTemplate_ng_template_0_div_7_Template, 4, 2, "div", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("no-time", !ctx_r0.showTime);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", "single-selection")("daysDisabled", ctx_r0.daysDisabled)("min", ctx_r0.min)("max", ctx_r0.max);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.selectedDate);
    i0.ɵɵproperty("startingDay", ctx_r0.startingDay)("specialDates", ctx_r0.specialDates);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.displayFooter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showTime);
  }
}
const _c2 = ["calendarIcon"];
function InputDateComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 8);
    i0.ɵɵelement(1, "path", 9);
    i0.ɵɵelementEnd();
  }
}
function InputDateComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 8);
    i0.ɵɵelement(1, "path", 10);
    i0.ɵɵelementEnd();
  }
}
function InputDateComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "sol-button", 12);
    i0.ɵɵlistener("onClick", function InputDateComponent_div_5_Template_sol_button_onClick_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.previousDateFn());
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "sol-button", 12);
    i0.ɵɵlistener("onClick", function InputDateComponent_div_5_Template_sol_button_onClick_3_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.nextDateFn());
    });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(1);
    const _r3 = i0.ɵɵreference(3);
    i0.ɵɵstyleProp("margin-top", ctx_r4.noLabel ? "0" : null);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(2, 12, "previousIcon"));
    i0.ɵɵproperty("variant", "basic")("size", "large")("iconPositionedFront", _r1)("disabled", ctx_r4.disabled || ctx_r4.readOnly || ctx_r4.overlayOpen || ctx_r4.selectedDate && ctx_r4.selectedDate <= ctx_r4.min || !ctx_r4.selectedDate);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(4, 14, "nextIcon"));
    i0.ɵɵproperty("variant", "basic")("size", "large")("iconPositionedFront", _r3)("disabled", ctx_r4.disabled || ctx_r4.readOnly || ctx_r4.overlayOpen || ctx_r4.selectedDate && ctx_r4.selectedDate >= ctx_r4.max || !ctx_r4.selectedDate);
  }
}
function InputDateComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 13, 14);
    i0.ɵɵlistener("overlayChanged", function InputDateComponent_ng_template_9_Template__svg_svg_overlayChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r13 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r13.overlayChange($event));
    });
    i0.ɵɵelement(2, "path", 15)(3, "path", 16)(4, "path", 17)(5, "path", 18)(6, "path", 19)(7, "path", 20)(8, "path", 21)(9, "path", 22)(10, "path", 23)(11, "path", 24)(12, "path", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(7);
    i0.ɵɵclassProp("svg-disabled", ctx_r6.readOnly || ctx_r6.disabled);
    i0.ɵɵproperty("solDateOverlay", ctx_r6.dateOverlayPanel)("solTextInput", _r5)("tabindex", ctx_r6.disabled || ctx_r6.readOnly ? -1 : 0);
  }
}
function InputDateComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "sol-button", 12);
    i0.ɵɵlistener("onClick", function InputDateComponent_div_11_Template_sol_button_onClick_1_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.previousDateFn());
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "sol-button", 12);
    i0.ɵɵlistener("onClick", function InputDateComponent_div_11_Template_sol_button_onClick_3_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.nextDateFn());
    });
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(1);
    const _r3 = i0.ɵɵreference(3);
    i0.ɵɵstyleProp("margin-top", ctx_r8.noLabel ? "0" : null);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(2, 12, "previousIcon"));
    i0.ɵɵproperty("variant", "basic")("size", "large")("iconPositionedFront", _r1)("disabled", ctx_r8.disabled || ctx_r8.readOnly || ctx_r8.overlayOpen || ctx_r8.selectedDate && ctx_r8.selectedDate <= ctx_r8.min || !ctx_r8.selectedDate);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(4, 14, "nextIcon"));
    i0.ɵɵproperty("variant", "basic")("size", "large")("iconPositionedFront", _r3)("disabled", ctx_r8.disabled || ctx_r8.readOnly || ctx_r8.overlayOpen || ctx_r8.selectedDate && ctx_r8.selectedDate >= ctx_r8.max || !ctx_r8.selectedDate);
  }
}
const _c3 = () => ({
  updateOn: "blur"
});
const _c4 = ["inputText"];
const _c5 = ["datepicker"];
const _c6 = ".sol-datepicker-wrapper{background:#fff;border:1px solid var(--color-interface-border1);box-shadow:0 4px 6px #0000003d;border-radius:var(--radii-small-allcorners)}.sol-datepicker-wrapper .date-time-container{display:flex;position:relative;width:30.5rem}.sol-datepicker-wrapper .date-time-container.no-time{width:20.5rem}.sol-datepicker-wrapper .date-time-container .calendar-container{width:20.5rem;position:relative}.sol-datepicker-wrapper .date-time-container .timepicker-container{box-sizing:border-box;height:100%;position:absolute;right:0;border-left:1px solid var(--color-interface-border1);width:10rem;padding:1.125rem}.sol-datepicker-wrapper .date-time-container .timepicker-container .timepicker{height:100%}.sol-datepicker-wrapper .footer{width:100%;border-top:1px solid var(--color-interface-border1);display:flex;justify-content:center}\n";
class DatepickerTemplate {
  constructor(cdr, translationService) {
    this.cdr = cdr;
    this.translationService = translationService;
    this.closed = new EventEmitter();
    this.disabledDateSelected = new EventEmitter();
    this.dateSelected = new EventEmitter();
    this._change = _ => {};
    this._controlValueAccessorTouchedFn = () => {};
  }
  onKeyUp(event) {
    if (event.key === 'Escape') {
      this.closed.emit();
    }
  }
  getTodayLabel() {
    return this.translationService.getTranslation('today');
  }
  dateSelection(date) {
    if (this.selectedDateTime) {
      this.setTime(date, this.selectedDateTime);
    }
    this._change(date);
    this.dateSelected.emit(date);
    if (!this.showTime) {
      this.closed.emit();
      return;
    }
    setTimeout(() => {
      this.timepicker.textInputEl.textInput.nativeElement.focus();
    }, 100);
  }
  timeSelection(date) {
    /* istanbul ignore else*/
    if (this.selectedDate) {
      this.setTime(this.selectedDate, this.selectedDateTime);
    } else if (!this.daysDisabled.includes(date.getDay())) {
      this.selectedDate = date;
    } else {
      this.disabledDateSelected.emit();
    }
    this._change(this.selectedDate);
    this.dateSelected.emit(this.selectedDate);
    this.closed.emit();
  }
  setTime(date, dateTime) {
    date.setHours(dateTime.getHours());
    date.setMinutes(dateTime.getMinutes());
    date.setSeconds(dateTime.getSeconds());
  }
  isWithinRange() {
    if (this.min && this.max) {
      const date = new Date();
      return date >= this.min && date <= this.max;
    }
    return true;
  }
  selectToday() {
    if (this.isWithinRange()) {
      this.calendarRef.calendar._goToDateInView(new Date(), 'month');
    }
  }
  writeValue(value) {
    this.selectedDate = value;
    this.selectedDateTime = value;
    this.cdr.markForCheck();
  }
  registerOnChange(fn) {
    this._change = fn;
  }
  registerOnTouched(fn) {
    this._controlValueAccessorTouchedFn = fn;
  }
  static {
    this.ɵfac = function DatepickerTemplate_Factory(t) {
      return new (t || DatepickerTemplate)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DatepickerTemplate,
      selectors: [["sol-datepicker-template"]],
      viewQuery: function DatepickerTemplate_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timepicker = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarRef = _t.first);
        }
      },
      hostBindings: function DatepickerTemplate_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup", function DatepickerTemplate_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        daysDisabled: "daysDisabled",
        startingDay: "startingDay",
        min: "min",
        max: "max",
        displayFooter: "displayFooter",
        showTime: "showTime",
        specialDates: "specialDates"
      },
      outputs: {
        closed: "closed",
        disabledDateSelected: "disabledDateSelected",
        dateSelected: "dateSelected"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatepickerTemplate),
        multi: true
      }])],
      decls: 1,
      vars: 0,
      consts: [[1, "sol-datepicker-wrapper"], ["datepickerTemplate", ""], [1, "date-time-container"], [1, "calendar-container"], [3, "type", "daysDisabled", "min", "max", "ngModel", "startingDay", "specialDates", "ngModelChange", "dateSelected"], ["calendar", ""], ["class", "footer", 4, "ngIf"], ["class", "timepicker-container", 4, "ngIf"], [1, "footer"], [3, "variant", "size", "ariaLabel", "disabledAltState", "disabled", "onClick"], [1, "timepicker-container"], [1, "timepicker"], [3, "ngModel", "alwaysOpen", "ngModelChange", "timeChanged"], ["timepicker", ""]],
      template: function DatepickerTemplate_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DatepickerTemplate_ng_template_0_Template, 8, 11, "ng-template");
        }
      },
      dependencies: [i2.NgIf, i3.CalendarComponent, i4.ButtonComponent, i5.NgControlStatus, i5.NgModel, i6.TimePickerComponent],
      styles: [".sol-datepicker-wrapper{background:#fff;border:1px solid var(--color-interface-border1);box-shadow:0 4px 6px #0000003d;border-radius:var(--radii-small-allcorners)}.sol-datepicker-wrapper .date-time-container{display:flex;position:relative;width:30.5rem}.sol-datepicker-wrapper .date-time-container.no-time{width:20.5rem}.sol-datepicker-wrapper .date-time-container .calendar-container{width:20.5rem;position:relative}.sol-datepicker-wrapper .date-time-container .timepicker-container{box-sizing:border-box;height:100%;position:absolute;right:0;border-left:1px solid var(--color-interface-border1);width:10rem;padding:1.125rem}.sol-datepicker-wrapper .date-time-container .timepicker-container .timepicker{height:100%}.sol-datepicker-wrapper .footer{width:100%;border-top:1px solid var(--color-interface-border1);display:flex;justify-content:center}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerTemplate, [{
    type: Component,
    args: [{
      selector: 'sol-datepicker-template',
      template: `
    <ng-template>
      <div class="sol-datepicker-wrapper" #datepickerTemplate>
        <div class="date-time-container" [class.no-time]="!showTime">
          <div class="calendar-container">
            <sol-calendar
              #calendar
              [type]="'single-selection'"
              [daysDisabled]="daysDisabled"
              [min]="min"
              [max]="max"
              [(ngModel)]="selectedDate"
              [startingDay]="startingDay"
              (dateSelected)="dateSelection($event)"
              [specialDates]="specialDates"
            ></sol-calendar>
            <div class="footer" *ngIf="displayFooter">
              <sol-button
                [variant]="'text'"
                [size]="'large'"
                (onClick)="selectToday()"
                [ariaLabel]="getTodayLabel()"
                [disabledAltState]="true"
                [disabled]="!isWithinRange()"
                >{{ getTodayLabel() }}</sol-button
              >
            </div>
          </div>
          <div class="timepicker-container" *ngIf="showTime">
            <div class="timepicker">
              <sol-time-picker #timepicker [(ngModel)]="selectedDateTime" [alwaysOpen]="true" (timeChanged)="timeSelection($event)">
              </sol-time-picker>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  `,
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatepickerTemplate),
        multi: true
      }],
      styles: [".sol-datepicker-wrapper{background:#fff;border:1px solid var(--color-interface-border1);box-shadow:0 4px 6px #0000003d;border-radius:var(--radii-small-allcorners)}.sol-datepicker-wrapper .date-time-container{display:flex;position:relative;width:30.5rem}.sol-datepicker-wrapper .date-time-container.no-time{width:20.5rem}.sol-datepicker-wrapper .date-time-container .calendar-container{width:20.5rem;position:relative}.sol-datepicker-wrapper .date-time-container .timepicker-container{box-sizing:border-box;height:100%;position:absolute;right:0;border-left:1px solid var(--color-interface-border1);width:10rem;padding:1.125rem}.sol-datepicker-wrapper .date-time-container .timepicker-container .timepicker{height:100%}.sol-datepicker-wrapper .footer{width:100%;border-top:1px solid var(--color-interface-border1);display:flex;justify-content:center}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1.TranslationService
  }], {
    daysDisabled: [{
      type: Input
    }],
    startingDay: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    displayFooter: [{
      type: Input
    }],
    showTime: [{
      type: Input
    }],
    specialDates: [{
      type: Input
    }],
    templateRef: [{
      type: ViewChild,
      args: [TemplateRef]
    }],
    timepicker: [{
      type: ViewChild,
      args: ['timepicker', {
        static: false
      }]
    }],
    calendarRef: [{
      type: ViewChild,
      args: ['calendar', {
        static: false
      }]
    }],
    closed: [{
      type: Output
    }],
    disabledDateSelected: [{
      type: Output
    }],
    dateSelected: [{
      type: Output
    }],
    onKeyUp: [{
      type: HostListener,
      args: ['document:keyup', ['$event']]
    }]
  });
})();
class DateOverlayDirective {
  constructor(overlay, viewContainerRef) {
    this.overlay = overlay;
    this.viewContainerRef = viewContainerRef;
    this.isDateOverlayOpen = false;
    this.datepickerClosingActionsSub = Subscription.EMPTY;
    this.overlayChanged = new EventEmitter();
  }
  toggleDateOverlay(event) {
    event.preventDefault();
    if (this.isDateOverlayOpen) {
      this.destroyDateOverlay();
    }
    this.openDateOverlay();
  }
  openDateOverlay() {
    this.isDateOverlayOpen = true;
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.close(),
      positionStrategy: this.overlay.position().flexibleConnectedTo(this.textInput).withPositions([{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 8,
        offsetX: 0
      }, {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
        offsetY: -8,
        offsetX: 0
      }])
    });
    const templatePortal = new TemplatePortal(this.dateOverlayrPanel.templateRef, this.viewContainerRef);
    this.overlayRef.attach(templatePortal);
    this.datepickerClosingActionsSub = this.dateOverlayClosingActions().subscribe(() => this.destroyDateOverlay());
    document.querySelector('.mat-calendar-body-active')?.focus();
    this.overlayChanged.emit(true);
  }
  dateOverlayClosingActions() {
    const backdropClick$ = this.overlayRef.backdropClick();
    const detachment$ = this.overlayRef.detachments();
    const datepickerClosed = this.dateOverlayrPanel.closed;
    return merge(backdropClick$, detachment$, datepickerClosed);
  }
  destroyDateOverlay() {
    if (!this.overlayRef || !this.isDateOverlayOpen) {
      return;
    }
    this.datepickerClosingActionsSub.unsubscribe();
    this.isDateOverlayOpen = false;
    this.overlayRef.detach();
    this.overlayChanged.emit(false);
  }
  ngOnDestroy() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
  static {
    this.ɵfac = function DateOverlayDirective_Factory(t) {
      return new (t || DateOverlayDirective)(i0.ɵɵdirectiveInject(i1$1.Overlay), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DateOverlayDirective,
      selectors: [["", "solDateOverlay", ""]],
      hostBindings: function DateOverlayDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DateOverlayDirective_click_HostBindingHandler($event) {
            return ctx.toggleDateOverlay($event);
          })("keydown.enter", function DateOverlayDirective_keydown_enter_HostBindingHandler($event) {
            return ctx.toggleDateOverlay($event);
          });
        }
      },
      inputs: {
        dateOverlayrPanel: [i0.ɵɵInputFlags.None, "solDateOverlay", "dateOverlayrPanel"],
        textInput: [i0.ɵɵInputFlags.None, "solTextInput", "textInput"]
      },
      outputs: {
        overlayChanged: "overlayChanged"
      },
      exportAs: ["solDateOverlay"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateOverlayDirective, [{
    type: Directive,
    args: [{
      selector: '[solDateOverlay]',
      host: {
        '(click)': 'toggleDateOverlay($event)',
        '(keydown.enter)': 'toggleDateOverlay($event)'
      },
      exportAs: 'solDateOverlay'
    }]
  }], () => [{
    type: i1$1.Overlay
  }, {
    type: i0.ViewContainerRef
  }], {
    dateOverlayrPanel: [{
      type: Input,
      args: ['solDateOverlay']
    }],
    textInput: [{
      type: Input,
      args: ['solTextInput']
    }],
    overlayChanged: [{
      type: Output
    }]
  });
})();
class InputDateComponent {
  previousDateFn() {
    if (this.min && this.selectedDate) {
      if (this.selectedDate > this.min) {
        this.prevDate.emit();
      }
    } else {
      this.prevDate.emit();
    }
  }
  nextDateFn() {
    if (this.max && this.selectedDate) {
      if (this.selectedDate < this.max) {
        this.nextDate.emit();
      }
    } else {
      this.nextDate.emit();
    }
  }
  overlayChange(state) {
    this.overlayOpen = state;
    this.overlayChanged.emit(state);
  }
  constructor(cdr, translationService) {
    this.cdr = cdr;
    this.translationService = translationService;
    this.errorMsg = null;
    this.disabled = false;
    this.readOnly = false;
    this.daysDisabled = [];
    this.nextDate = new EventEmitter();
    this.prevDate = new EventEmitter();
    this.overlayChanged = new EventEmitter();
    this.label = null;
    this.noLabel = false;
    this.ariaLabel = '';
    this.ariaLabelledby = null;
    this.overlayOpen = false;
    this._change = _ => {};
    this._controlValueAccessorTouchedFn = () => {};
  }
  getLabel() {
    if (this.noLabel) {
      return '';
    } else if (this.label) {
      return this.label;
    }
    return this.translationService.getTranslation('enterDate');
  }
  isValidDate(dateString) {
    try {
      new Intl.DateTimeFormat().format(new Date(dateString));
      this.errorMsg = null;
      return true;
    } catch (e) {
      this.errorMsg = 'not a valid date';
      this.selectedDate = null;
      this._change(this.selectedDate);
      return false;
    }
  }
  get formattedDate() {
    return new DatePipe(navigator.language).transform(this.selectedDate, this.format);
  }
  set formattedDate(date) {
    if (date) {
      if (this.isValidDate(date)) {
        if (this.daysDisabled.includes(new Date(date).getDay())) {
          this.errorMsg = 'Entered date is disabled';
          this.selectedDate = null;
          this._change(this.selectedDate);
          return;
        }
        if (this.min && this.max && new Date(date) < this.min || new Date(date) > this.max) {
          this.errorMsg = 'not a valid date';
          this.selectedDate = null;
          this._change(this.selectedDate);
          return;
        }
        this.selectedDate = new Date(date);
        this._change(this.selectedDate);
      }
    } else {
      this.selectedDate = null;
      this._change(this.selectedDate);
      this.errorMsg = null;
    }
  }
  writeValue(value) {
    if (value) {
      this.selectedDate = new Date(value);
      this.errorMsg = null;
      this.cdr.detectChanges();
    }
  }
  registerOnChange(fn) {
    this._change = fn;
  }
  registerOnTouched(fn) {
    this._controlValueAccessorTouchedFn = fn;
  }
  static {
    this.ɵfac = function InputDateComponent_Factory(t) {
      return new (t || InputDateComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InputDateComponent,
      selectors: [["sol-input-date"]],
      viewQuery: function InputDateComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarIcon = _t.first);
        }
      },
      inputs: {
        errorMsg: "errorMsg",
        dateOverlayPanel: "dateOverlayPanel",
        format: "format",
        disabled: "disabled",
        readOnly: "readOnly",
        daysDisabled: "daysDisabled",
        showActionArrows: "showActionArrows",
        arrowPosition: "arrowPosition",
        min: "min",
        max: "max",
        label: "label",
        noLabel: "noLabel",
        ariaLabel: "ariaLabel",
        ariaLabelledby: "ariaLabelledby"
      },
      outputs: {
        nextDate: "nextDate",
        prevDate: "prevDate",
        overlayChanged: "overlayChanged"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputDateComponent),
        multi: true
      }])],
      decls: 12,
      vars: 12,
      consts: [["previous", ""], ["next", ""], [1, "sol-input-container"], ["class", "button-container", 3, "marginTop", 4, "ngIf"], [1, "input-text"], ["inputText", ""], [3, "trailingIcon", "labelText", "ngModel", "ngModelOptions", "errorMessageText", "readonly", "disabled", "aria-label", "aria-labelledby", "ngModelChange"], ["Icon", ""], ["width", "6.4", "height", "12.8", "viewBox", "0 0 8 14", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0.981181 6.20399L6.11326 0.791051C6.35477 0.536325 6.77741 0.536325 7.01892 0.791051C7.26043 1.04578 7.26043 1.49155 7.01892 1.74627L2.18873 6.8408L7.01892 12.2537C7.26043 12.5085 7.26043 12.9542 7.01892 13.209C6.77741 13.4637 6.35477 13.4637 6.11326 13.209L0.981181 7.47762C0.800049 7.28657 0.800049 7.09553 0.800049 6.90448C0.800049 6.58608 0.860426 6.33135 0.981181 6.20399Z", "fill", "currentColor"], ["d", "M7.01892 6.20399L1.88684 0.791051C1.64533 0.536325 1.22269 0.536325 0.981181 0.791051C0.739671 1.04578 0.739671 1.49155 0.981181 1.74627L5.81137 6.8408L0.981181 12.2537C0.739671 12.5085 0.739671 12.9542 0.981181 13.209C1.22269 13.4637 1.64533 13.4637 1.88684 13.209L7.01892 7.47762C7.20005 7.28657 7.20005 7.09553 7.20005 6.90448C7.20005 6.58608 7.13967 6.33135 7.01892 6.20399Z", "fill", "currentColor"], [1, "button-container"], [3, "variant", "size", "iconPositionedFront", "disabled", "ariaLabel", "onClick"], ["width", "20", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "calendar-icon", 3, "solDateOverlay", "solTextInput", "tabindex", "overlayChanged"], ["calendarIcon", ""], ["d", "M17.5 2H15.5V0H13.5V2H6.5V0H4.5V2H2.5C1.39562 2 0.5 2.89563 0.5 4V18C0.5 19.1044 1.39562 20 2.5 20H17.5C18.6044 20 19.5 19.1044 19.5 18V4C19.5 2.89563 18.6044 2 17.5 2ZM17.5 18H2.5V8H17.5V18ZM17.5 6H2.5V4H4.5V5H6.5V4H13.5V5H15.5V4H17.5V6Z", "fill", "black"], ["d", "M10.5 9H12.5V11H10.5V9Z", "fill", "black"], ["d", "M10.5 12H12.5V14H10.5V12Z", "fill", "black"], ["d", "M10.5 15H12.5V17H10.5V15Z", "fill", "black"], ["d", "M7.5 9H9.5V11H7.5V9Z", "fill", "black"], ["d", "M7.5 12H9.5V14H7.5V12Z", "fill", "black"], ["d", "M7.5 15H9.5V17H7.5V15Z", "fill", "black"], ["d", "M4.5 12H6.5V14H4.5V12Z", "fill", "black"], ["d", "M4.5 15H6.5V17H4.5V15Z", "fill", "black"], ["d", "M13.5 9H15.5V11H13.5V9Z", "fill", "black"], ["d", "M13.5 12H15.5V14H13.5V12Z", "fill", "black"]],
      template: function InputDateComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, InputDateComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, InputDateComponent_ng_template_2_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementStart(4, "div", 2);
          i0.ɵɵtemplate(5, InputDateComponent_div_5_Template, 5, 16, "div", 3);
          i0.ɵɵelementStart(6, "div", 4, 5)(8, "sol-text-input", 6);
          i0.ɵɵtwoWayListener("ngModelChange", function InputDateComponent_Template_sol_text_input_ngModelChange_8_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.formattedDate, $event) || (ctx.formattedDate = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, InputDateComponent_ng_template_9_Template, 13, 5, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, InputDateComponent_div_11_Template, 5, 16, "div", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          const _r7 = i0.ɵɵreference(10);
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", ctx.showActionArrows && ctx.arrowPosition === "left");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("trailingIcon", _r7)("labelText", ctx.getLabel());
          i0.ɵɵtwoWayProperty("ngModel", ctx.formattedDate);
          i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(11, _c3))("errorMessageText", ctx.errorMsg)("readonly", ctx.readOnly)("disabled", ctx.disabled)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.ariaLabelledby);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.showActionArrows && ctx.arrowPosition === "right");
        }
      },
      dependencies: [i2.NgIf, i3$1.TextInputComponent, i4.ButtonComponent, i5.NgControlStatus, i5.NgModel, DateOverlayDirective, i1.TranslationPipe],
      styles: [".sol-input-container{display:flex;gap:var(--outline-offset4)}.sol-input-container .input-text{width:18.75rem}.sol-input-container .input-text .calendar-icon{outline:none}.sol-input-container .input-text .calendar-icon:focus-visible{outline:1px solid var(--color-globalstate-focus);outline-offset:var(--outline-offset4)}.sol-input-container .input-text .calendar-icon.svg-disabled{pointer-events:none}.sol-input-container .input-text .calendar-icon.svg-disabled path{fill:var(--color-globalstate-disabled-border)}.sol-input-container .button-container{display:flex;gap:var(--outline-offset4);margin-top:1.25rem}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputDateComponent, [{
    type: Component,
    args: [{
      selector: 'sol-input-date',
      template: `
    <ng-template #previous>
      <svg width="6.4" height="12.8" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.981181 6.20399L6.11326 0.791051C6.35477 0.536325 6.77741 0.536325 7.01892 0.791051C7.26043 1.04578 7.26043 1.49155 7.01892 1.74627L2.18873 6.8408L7.01892 12.2537C7.26043 12.5085 7.26043 12.9542 7.01892 13.209C6.77741 13.4637 6.35477 13.4637 6.11326 13.209L0.981181 7.47762C0.800049 7.28657 0.800049 7.09553 0.800049 6.90448C0.800049 6.58608 0.860426 6.33135 0.981181 6.20399Z"
          fill="currentColor"
        />
      </svg>
    </ng-template>
    <ng-template #next>
      <svg width="6.4" height="12.8" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.01892 6.20399L1.88684 0.791051C1.64533 0.536325 1.22269 0.536325 0.981181 0.791051C0.739671 1.04578 0.739671 1.49155 0.981181 1.74627L5.81137 6.8408L0.981181 12.2537C0.739671 12.5085 0.739671 12.9542 0.981181 13.209C1.22269 13.4637 1.64533 13.4637 1.88684 13.209L7.01892 7.47762C7.20005 7.28657 7.20005 7.09553 7.20005 6.90448C7.20005 6.58608 7.13967 6.33135 7.01892 6.20399Z"
          fill="currentColor"
        />
      </svg>
    </ng-template>
    <div class="sol-input-container">
      <div class="button-container" *ngIf="showActionArrows && arrowPosition === 'left'" [style.marginTop]="noLabel ? '0' : null">
        <sol-button
          [variant]="'basic'"
          [size]="'large'"
          (onClick)="previousDateFn()"
          [iconPositionedFront]="previous"
          [disabled]="disabled || readOnly || overlayOpen || (selectedDate && selectedDate <= min) || !selectedDate"
          ariaLabel="{{ 'previousIcon' | translate }}"
        ></sol-button>
        <sol-button
          [variant]="'basic'"
          [size]="'large'"
          (onClick)="nextDateFn()"
          [iconPositionedFront]="next"
          [disabled]="disabled || readOnly || overlayOpen || (selectedDate && selectedDate >= max) || !selectedDate"
          ariaLabel="{{ 'nextIcon' | translate }}"
        ></sol-button>
      </div>
      <div class="input-text" #inputText>
        <sol-text-input
          [trailingIcon]="Icon"
          [labelText]="getLabel()"
          [(ngModel)]="formattedDate"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [errorMessageText]="errorMsg"
          [readonly]="readOnly"
          [disabled]="disabled"
          [aria-label]="ariaLabel"
          [aria-labelledby]="ariaLabelledby"
        ></sol-text-input>
        <ng-template #Icon>
          <svg
            #calendarIcon
            [class.svg-disabled]="readOnly || disabled"
            [solDateOverlay]="dateOverlayPanel"
            [solTextInput]="inputText"
            (overlayChanged)="overlayChange($event)"
            class="calendar-icon"
            [tabindex]="disabled || readOnly ? -1 : 0"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 2H15.5V0H13.5V2H6.5V0H4.5V2H2.5C1.39562 2 0.5 2.89563 0.5 4V18C0.5 19.1044 1.39562 20 2.5 20H17.5C18.6044 20 19.5 19.1044 19.5 18V4C19.5 2.89563 18.6044 2 17.5 2ZM17.5 18H2.5V8H17.5V18ZM17.5 6H2.5V4H4.5V5H6.5V4H13.5V5H15.5V4H17.5V6Z"
              fill="black"
            />
            <path d="M10.5 9H12.5V11H10.5V9Z" fill="black" />
            <path d="M10.5 12H12.5V14H10.5V12Z" fill="black" />
            <path d="M10.5 15H12.5V17H10.5V15Z" fill="black" />
            <path d="M7.5 9H9.5V11H7.5V9Z" fill="black" />
            <path d="M7.5 12H9.5V14H7.5V12Z" fill="black" />
            <path d="M7.5 15H9.5V17H7.5V15Z" fill="black" />
            <path d="M4.5 12H6.5V14H4.5V12Z" fill="black" />
            <path d="M4.5 15H6.5V17H4.5V15Z" fill="black" />
            <path d="M13.5 9H15.5V11H13.5V9Z" fill="black" />
            <path d="M13.5 12H15.5V14H13.5V12Z" fill="black" />
          </svg>
        </ng-template>
      </div>
      <div class="button-container" *ngIf="showActionArrows && arrowPosition === 'right'" [style.marginTop]="noLabel ? '0' : null">
        <sol-button
          [variant]="'basic'"
          [size]="'large'"
          (onClick)="previousDateFn()"
          [iconPositionedFront]="previous"
          [disabled]="disabled || readOnly || overlayOpen || (selectedDate && selectedDate <= min) || !selectedDate"
          ariaLabel="{{ 'previousIcon' | translate }}"
        ></sol-button>
        <sol-button
          [variant]="'basic'"
          [size]="'large'"
          (onClick)="nextDateFn()"
          [iconPositionedFront]="next"
          [disabled]="disabled || readOnly || overlayOpen || (selectedDate && selectedDate >= max) || !selectedDate"
          ariaLabel="{{ 'nextIcon' | translate }}"
        ></sol-button>
      </div>
    </div>
  `,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputDateComponent),
        multi: true
      }],
      styles: [".sol-input-container{display:flex;gap:var(--outline-offset4)}.sol-input-container .input-text{width:18.75rem}.sol-input-container .input-text .calendar-icon{outline:none}.sol-input-container .input-text .calendar-icon:focus-visible{outline:1px solid var(--color-globalstate-focus);outline-offset:var(--outline-offset4)}.sol-input-container .input-text .calendar-icon.svg-disabled{pointer-events:none}.sol-input-container .input-text .calendar-icon.svg-disabled path{fill:var(--color-globalstate-disabled-border)}.sol-input-container .button-container{display:flex;gap:var(--outline-offset4);margin-top:1.25rem}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1.TranslationService
  }], {
    errorMsg: [{
      type: Input
    }],
    dateOverlayPanel: [{
      type: Input
    }],
    format: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    readOnly: [{
      type: Input
    }],
    daysDisabled: [{
      type: Input
    }],
    nextDate: [{
      type: Output
    }],
    prevDate: [{
      type: Output
    }],
    overlayChanged: [{
      type: Output
    }],
    showActionArrows: [{
      type: Input
    }],
    arrowPosition: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    noLabel: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    ariaLabelledby: [{
      type: Input
    }],
    calendarIcon: [{
      type: ViewChild,
      args: ['calendarIcon', {
        static: false
      }]
    }]
  });
})();
class DatepickerComponent {
  constructor(cdr) {
    this.cdr = cdr;
    this.showTime = false;
    this.displayFooter = true;
    this.specialDates = [];
    this.startingDay = 0;
    this.daysDisabled = [];
    this.showActionArrows = true;
    this.arrowPosition = 'right';
    this.disabled = false;
    this.readOnly = false;
    this.label = null;
    this.noLabel = false;
    this.ariaLabel = '';
    this.ariaLabelledby = null;
    this.timeRegex = /\bh:mm\b|\bhh:mm\b|\bhh:mm:ss\b/;
    this.overlayOpen = false;
    this.errorMsg = null;
    this._change = _ => {};
    this._controlValueAccessorTouchedFn = () => {};
  }
  ngOnInit() {
    if (this.timeRegex.test(this.format)) {
      this.showTime = true;
    }
  }
  onKeyUp(event) {
    if (event.key === 'Enter' && !this.overlayOpen) {
      this.inputText.calendarIcon.nativeElement.focus();
    }
  }
  toggleOverlay(state) {
    this.overlayOpen = state;
    if (!state) {
      this.inputText.calendarIcon.nativeElement.focus();
    }
  }
  disabledDateSelectedFn() {
    this.errorMsg = 'selected date is disabled';
  }
  dateSelection(date) {
    if (this.selectedDate && !this.daysDisabled.includes(this.selectedDate.getDay())) {
      this.selectedDate = new Date(date);
      this.errorMsg = null;
      this._change(this.selectedDate);
    }
  }
  onChange(date) {
    this._change(date);
  }
  isDisabledNext(date) {
    const nextDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    if (this.daysDisabled.includes(nextDay.getDay())) {
      return this.isDisabledNext(nextDay);
    }
    return nextDay;
  }
  isDisabledPrev(date) {
    const prevDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
    if (this.daysDisabled.includes(prevDay.getDay())) {
      return this.isDisabledPrev(prevDay);
    }
    return prevDay;
  }
  nextDate() {
    if (this.selectedDate) {
      const temp = this.selectedDate;
      this.selectedDate = this.isDisabledNext(this.selectedDate);
      this.selectedDate.setHours(temp.getHours());
      this.selectedDate.setMinutes(temp.getMinutes());
      this.selectedDate.setSeconds(temp.getSeconds());
      this._change(this.selectedDate);
    }
  }
  previousDate() {
    if (this.selectedDate) {
      const temp = this.selectedDate;
      this.selectedDate = this.isDisabledPrev(this.selectedDate);
      this.selectedDate.setHours(temp.getHours());
      this.selectedDate.setMinutes(temp.getMinutes());
      this.selectedDate.setSeconds(temp.getSeconds());
      this._change(this.selectedDate);
    }
  }
  writeValue(value) {
    if (value) {
      if (!this.daysDisabled.includes(value.getDay())) {
        if (this.min && this.max && value < this.min || value > this.max) {
          this.errorMsg = 'not a valid date';
          return;
        }
        this.selectedDate = new Date(value);
        this.cdr.detectChanges();
      } else {
        this.errorMsg = 'Entered date is disabled';
      }
    }
  }
  registerOnChange(fn) {
    this._change = fn;
  }
  registerOnTouched(fn) {
    this._controlValueAccessorTouchedFn = fn;
  }
  static {
    this.ɵfac = function DatepickerComponent_Factory(t) {
      return new (t || DatepickerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DatepickerComponent,
      selectors: [["sol-datepicker"]],
      viewQuery: function DatepickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputText = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datepicker = _t.first);
        }
      },
      hostBindings: function DatepickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup", function DatepickerComponent_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        format: "format",
        displayFooter: "displayFooter",
        min: "min",
        max: "max",
        specialDates: "specialDates",
        startingDay: "startingDay",
        daysDisabled: "daysDisabled",
        showActionArrows: "showActionArrows",
        arrowPosition: "arrowPosition",
        disabled: "disabled",
        readOnly: "readOnly",
        label: "label",
        noLabel: "noLabel",
        ariaLabel: [i0.ɵɵInputFlags.None, "aria-label", "ariaLabel"],
        ariaLabelledby: [i0.ɵɵInputFlags.None, "aria-labelledby", "ariaLabelledby"]
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatepickerComponent),
        multi: true
      }])],
      decls: 4,
      vars: 24,
      consts: [[3, "format", "dateOverlayPanel", "ngModel", "readOnly", "disabled", "arrowPosition", "showActionArrows", "min", "max", "daysDisabled", "errorMsg", "ariaLabel", "ariaLabelledby", "label", "noLabel", "ngModelChange", "nextDate", "prevDate", "overlayChanged"], ["inputText", ""], [3, "ngModel", "showTime", "displayFooter", "min", "max", "daysDisabled", "startingDay", "specialDates", "ngModelChange", "dateSelected", "disabledDateSelected"], ["datepicker", ""]],
      template: function DatepickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "sol-input-date", 0, 1);
          i0.ɵɵtwoWayListener("ngModelChange", function DatepickerComponent_Template_sol_input_date_ngModelChange_0_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedDate, $event) || (ctx.selectedDate = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function DatepickerComponent_Template_sol_input_date_ngModelChange_0_listener($event) {
            return ctx.onChange($event);
          })("nextDate", function DatepickerComponent_Template_sol_input_date_nextDate_0_listener() {
            return ctx.nextDate();
          })("prevDate", function DatepickerComponent_Template_sol_input_date_prevDate_0_listener() {
            return ctx.previousDate();
          })("overlayChanged", function DatepickerComponent_Template_sol_input_date_overlayChanged_0_listener($event) {
            return ctx.toggleOverlay($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "sol-datepicker-template", 2, 3);
          i0.ɵɵtwoWayListener("ngModelChange", function DatepickerComponent_Template_sol_datepicker_template_ngModelChange_2_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedDate, $event) || (ctx.selectedDate = $event);
            return $event;
          });
          i0.ɵɵlistener("dateSelected", function DatepickerComponent_Template_sol_datepicker_template_dateSelected_2_listener($event) {
            return ctx.dateSelection($event);
          })("disabledDateSelected", function DatepickerComponent_Template_sol_datepicker_template_disabledDateSelected_2_listener() {
            return ctx.disabledDateSelectedFn();
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          const _r1 = i0.ɵɵreference(3);
          i0.ɵɵproperty("format", ctx.format)("dateOverlayPanel", _r1);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedDate);
          i0.ɵɵproperty("readOnly", ctx.readOnly || ctx.overlayOpen)("disabled", ctx.disabled)("arrowPosition", ctx.arrowPosition)("showActionArrows", ctx.showActionArrows)("min", ctx.min)("max", ctx.max)("daysDisabled", ctx.daysDisabled)("errorMsg", ctx.errorMsg)("ariaLabel", ctx.ariaLabel)("ariaLabelledby", ctx.ariaLabelledby)("label", ctx.label)("noLabel", ctx.noLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedDate);
          i0.ɵɵproperty("showTime", ctx.showTime)("displayFooter", ctx.displayFooter)("min", ctx.min)("max", ctx.max)("daysDisabled", ctx.daysDisabled)("startingDay", ctx.startingDay)("specialDates", ctx.specialDates)("displayFooter", ctx.displayFooter);
        }
      },
      dependencies: [i5.NgControlStatus, i5.NgModel, DatepickerTemplate, InputDateComponent],
      styles: [_c6],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerComponent, [{
    type: Component,
    args: [{
      selector: 'sol-datepicker',
      template: `
    <sol-input-date
      #inputText
      [format]="format"
      [dateOverlayPanel]="datepicker"
      [(ngModel)]="selectedDate"
      (ngModelChange)="onChange($event)"
      (nextDate)="nextDate()"
      (prevDate)="previousDate()"
      [readOnly]="readOnly || overlayOpen"
      [disabled]="disabled"
      [arrowPosition]="arrowPosition"
      [showActionArrows]="showActionArrows"
      [min]="min"
      [max]="max"
      [daysDisabled]="daysDisabled"
      [errorMsg]="errorMsg"
      [ariaLabel]="ariaLabel"
      [ariaLabelledby]="ariaLabelledby"
      [label]="label"
      [noLabel]="noLabel"
      (overlayChanged)="toggleOverlay($event)"
    ></sol-input-date>
    <sol-datepicker-template
      #datepicker
      [(ngModel)]="selectedDate"
      (dateSelected)="dateSelection($event)"
      (disabledDateSelected)="disabledDateSelectedFn()"
      [showTime]="showTime"
      [displayFooter]="displayFooter"
      [min]="min"
      [max]="max"
      [daysDisabled]="daysDisabled"
      [startingDay]="startingDay"
      [specialDates]="specialDates"
      [displayFooter]="displayFooter"
    ></sol-datepicker-template>
  `,
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatepickerComponent),
        multi: true
      }],
      styles: [".sol-datepicker-wrapper{background:#fff;border:1px solid var(--color-interface-border1);box-shadow:0 4px 6px #0000003d;border-radius:var(--radii-small-allcorners)}.sol-datepicker-wrapper .date-time-container{display:flex;position:relative;width:30.5rem}.sol-datepicker-wrapper .date-time-container.no-time{width:20.5rem}.sol-datepicker-wrapper .date-time-container .calendar-container{width:20.5rem;position:relative}.sol-datepicker-wrapper .date-time-container .timepicker-container{box-sizing:border-box;height:100%;position:absolute;right:0;border-left:1px solid var(--color-interface-border1);width:10rem;padding:1.125rem}.sol-datepicker-wrapper .date-time-container .timepicker-container .timepicker{height:100%}.sol-datepicker-wrapper .footer{width:100%;border-top:1px solid var(--color-interface-border1);display:flex;justify-content:center}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    format: [{
      type: Input
    }],
    displayFooter: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    specialDates: [{
      type: Input
    }],
    startingDay: [{
      type: Input
    }],
    daysDisabled: [{
      type: Input
    }],
    showActionArrows: [{
      type: Input
    }],
    arrowPosition: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    readOnly: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    noLabel: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input,
      args: ['aria-label']
    }],
    ariaLabelledby: [{
      type: Input,
      args: ['aria-labelledby']
    }],
    inputText: [{
      type: ViewChild,
      args: ['inputText']
    }],
    datepicker: [{
      type: ViewChild,
      args: ['datepicker']
    }],
    onKeyUp: [{
      type: HostListener,
      args: ['document:keyup', ['$event']]
    }]
  });
})();
class DatepickerModule {
  static {
    this.ɵfac = function DatepickerModule_Factory(t) {
      return new (t || DatepickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DatepickerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [languageInitializerProvider],
      imports: [CommonModule, CalendarModule, TextInputModule, ButtonModule, FormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }), TimePickerModule, OverlayModule, TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerModule, [{
    type: NgModule,
    args: [{
      declarations: [DatepickerTemplate, DatepickerComponent, InputDateComponent, DateOverlayDirective],
      imports: [CommonModule, CalendarModule, TextInputModule, ButtonModule, FormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }), TimePickerModule, OverlayModule, TranslationModule],
      providers: [languageInitializerProvider],
      exports: [DatepickerTemplate, DatepickerComponent, InputDateComponent, DateOverlayDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DateOverlayDirective, DatepickerComponent, DatepickerModule, DatepickerTemplate, InputDateComponent };
